module.exports = __webpack_public_path__ + "static/img/010酒庄官网1.fee40c0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/smPicImgs/010酒庄官网1.jpg
// module id = 57ul
// module chunks = 0